<template>
    <div class="stat-list">
      <h3>{{ $t('randevu.stats.per_expert.title') }}</h3>
      <div v-if="experts.length">
        <div v-for="e in experts" :key="e.expert_id" class="expert-item">
          <span class="expert-name">{{ e.expert_name }}</span>
          <span class="expert-appointments">{{ e.total }} {{ $t('randevu.stats.per_expert.appointments_suffix') }}</span>
        </div>
      </div>
      <p style="color: #917e5c ;" v-else>{{ $t('randevu.stats.per_expert.empty') }}</p>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  export default {
    name: 'AppointmentsPerExpertBar',
    data() { return { experts: [] }; },
    async created() {
      try {
        const { data } = await axios.get('/promo/user/stats/appointments-per-expert');
        this.experts = data;
      } catch (err) { 
        console.error('Veri alınamadı:', err); 
        this.experts = [];  
      }
    }
  };
  </script>
  
  <style scoped>
  .stat-list {
    padding: 1rem;
    background-color: #050505;  
    border-radius: 6px;
    margin-top: 1em;
  }
  
  h3 {
    margin-bottom: 0.5rem;
    font-size: 1rem; 
    font-weight: 400;
  }
  
  .expert-item {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 0; 
    border-bottom: 1px solid #023032;
  }
  
  .expert-name {
    font-weight: 500;
  }
  
  .expert-appointments {
    font-style: italic; 
  }
   
  </style>
  